// @flow
import { isPostalCode, isPresent } from "Commons/Utilities/validators";

export const postCodeValidator = isPostalCode;
export const locationIdValidator = (n: string) => n && isPresent(n);
